// src/components/PageShell.tsx
import React from "react";
import { Container, Box } from "@mui/material";

type Props = { children: React.ReactNode };

export default function PageShell({ children }: Props) {
  return (
    <Container maxWidth="md" sx={{ py: { xs: 4, md: 6 } }}>
      <Box
        sx={{
          p: { xs: 3, md: 4 },
          borderRadius: 3,
          boxShadow: 1,
          bgcolor: "background.paper",
        }}
      >
        {children}
      </Box>
    </Container>
  );
}
